import { useReducedMotion } from "framer-motion";

const GAP = 10;

// Height and margin animate with the card so exiting cards give up their space
// as they leave; framer-motion 6 `layout` let siblings overlap mid-exit.
export const useDockMotion = () => {
  const reduced = useReducedMotion();
  const hidden = reduced
    ? { opacity: 0 }
    : { opacity: 0, height: 0, marginTop: 0, overflow: "hidden" };
  return {
    initial: reduced ? { opacity: 0, marginTop: GAP } : hidden,
    animate: {
      opacity: 1,
      height: "auto",
      marginTop: GAP,
      transitionEnd: { overflow: "visible" },
      transition: { duration: 0.2, ease: "easeOut" },
    },
    exit: { ...hidden, transition: { duration: 0.15, ease: "easeIn" } },
  };
};
